// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"584":"f52956b0","885":"f52956b0"}[chunkId] + ".chunk.css";
};